import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';

import Agent from '../api/Agent';
import { handleError } from './user';
import { getClientProperties } from '../utils/client';
import mixpanelConstants from '../constants/mixpanel';

const INITIAL_STATE = {
	isSubmitting: false,
	open: false,
	submitStatus: null,
	userFeedback: null
};

export const resetSubmit = createAction('RESET_FEEDBACK_SUBMIT');
export const setUserFeedback = createAction('SET_USER_FEEDBACK');
export const setSubmitted = createAction('SET_FEEDBACK_SUBMITTED');
export const setErrorModalOpen = createAction('SET_ERROR_MODAL_OPEN');
export const setIsSubmittingError = createAction('SET_IS_SUBMITTING_ERROR');

const reducer = handleActions(
	{
		RESET_FEEDBACK_SUBMIT: (state) => ({ ...INITIAL_STATE, open: state.open }),
		SET_ERROR_MODAL_OPEN: (state, action) => ({ ...state, open: action.payload }),
		SET_FEEDBACK_SUBMITTED: (state, action) => ({ ...state, submitStatus: action.payload }),
		SET_IS_SUBMITTING_ERROR: (state, action) => ({ ...state, isSubmitting: action.payload }),
		SET_USER_FEEDBACK: (state, action) => ({ ...state, userFeedback: action.payload })
	},
	INITIAL_STATE
);

export const openModal =
	(open = true) =>
	(dispatch) => {
		dispatch(resetSubmit());
		dispatch(setErrorModalOpen(open));
	};

export const reportError = (errorDetails) => (dispatch) => {
	const report = {
		...errorDetails,
		client: getClientProperties()
	};

	dispatch(setSubmitted(null));
	dispatch(setIsSubmittingError(true));

	return Agent.reportError(report).then((response) => {
		dispatch(setIsSubmittingError(false));
		if (response.ok) {
			dispatch(setSubmitted(true));
			mixpanel.track(mixpanelConstants.SUBMIT_FEEDBACK_FORM, { feedbackMessage: report.content });
		} else {
			dispatch(setSubmitted(false));
			dispatch(handleError(response));
		}
	});
};

export default reducer;
